import * as React from 'react';

import { QuestionTypes } from '@showbie-socrative/socrative-utils';

import { QuestionMatching } from '~teacher/components/QuestionMatching/QuestionMatching';
import QuestionMultipleChoice from '~teacher/components/QuestionMultipleChoice/QuestionMultipleChoice';
import QuestionShortAnswer from '~teacher/components/QuestionShortAnswer/QuestionShortAnswer';
import QuestionTrueFalse from '~teacher/components/QuestionTrueFalse/QuestionTrueFalse';

interface QuestionTypeProps {
  questionId: string;
  questionType: QuestionTypes;
  order: number;
  hasCustomGradingWeight: boolean;
  isLocked: boolean;
}

function QuestionType(props: QuestionTypeProps) {
  switch (props.questionType) {
    case QuestionTypes.MultipleChoice: {
      return <QuestionMultipleChoice {...props} />;
    }
    case QuestionTypes.TrueFalse: {
      return <QuestionTrueFalse {...props} />;
    }
    case QuestionTypes.FreeResponse: {
      return <QuestionShortAnswer {...props} />;
    }
    case QuestionTypes.Matching: {
      return <QuestionMatching {...props} />;
    }
    default:
      return (
        <div>
          Question ID: {props.questionId} is an unsupported question type.
          {props.questionType}
        </div>
      );
  }
}

export default QuestionType;
